import { createListenerMiddleware } from '@reduxjs/toolkit';

import { CoreLobbyMessageController } from '../../../messages/CoreLobbyMessageController';
import { updateBalanceMessage } from '../../../messages/messages/updateBalance/updateBalanceMessage';
import { countTotalBet, isFreeBetPlaced } from '../../../utils/bets';
import { postClaimBonusAction } from '../../apiActions/fetchBonusPromotionAction';
import { CorePredicator } from '../../CorePredicator';
import type { CoreRootState } from '../../CoreStore';
import { ChipTypes } from '../chips/types';

import { selectCompositeBalance } from './rawSelectors';
import { betActions, pushAutoplayBet } from './slice';

export const betMiddleware = createListenerMiddleware<CoreRootState>();

betMiddleware.startListening({
  predicate: (_action, currentState, originalState) => {
    const currentBetStack = currentState.bets.betStack;
    const originalBetStack = originalState.bets.betStack;
    return currentBetStack !== originalBetStack;
  },
  effect: (_action, { dispatch, getState }) => {
    const state = getState();
    const bets = state.bets.betStack?.[state.bets.betStack.length - 1];
    const decimals = state.gameState.currencyInfo?.digitsNumber ?? 2;
    const totalBet = bets ? countTotalBet(bets.betSpots, decimals) : 0;
    dispatch(betActions.setRawTotalBet(totalBet));
    const betType = isFreeBetPlaced(bets?.betSpots) ? ChipTypes.FreeChip : ChipTypes.CasinoChip;
    const placedBetType = totalBet > 0 ? betType : '';
    dispatch(betActions.setPlacedBetType(placedBetType));
  },
});

// dispatching balance changes to the lobby
betMiddleware.startListening(
  CorePredicator.createListener(
    (state) => [selectCompositeBalance(state), state.bets.totalBet] as const,
    ([balance, totalBet]) => {
      CoreLobbyMessageController.post(
        updateBalanceMessage({
          amount: balance.amount,
          bonus: balance.bonus,
          totalBet,
        })
      );
    },
    { mode: 'change' }
  )
);

betMiddleware.startListening({
  actionCreator: pushAutoplayBet,
  effect: (action, { dispatch }) => {
    dispatch(betActions.pushBet(action.payload));
  },
});

betMiddleware.startListening({
  actionCreator: postClaimBonusAction.fulfilled,
  effect: (_action, { dispatch, getState }) => {
    const state = getState();
    if (isFreeBetPlaced(state.bets.lastBet?.betSpots)) {
      dispatch(betActions.clearLastBets());
    }
  },
});
